<template>
  <div class="users">
    <a-form
      v-if="!showEditBox"
      class="searchBox"
    >
      <a-row>
        <!-- 名称 -->
        <a-col :span="3">
          {{ $t('admin-message-message/name') }}
        </a-col>
        <!-- 输入框 -->
        <a-col :span="9">
          <a-input
            v-model="searchWord"
            :placeholder="$t('admin-user-user/namee')"
          />
        </a-col>
        <!-- 搜索按钮 -->
        <a-col :span="6">
          <a-button
            type="primary"
            @click="getList"
          >
            {{ $t('user-productInfo-myProduct/search') }}
          </a-button>
        </a-col>
        <!-- 添加用户按钮 -->
        <a-col :span="6">
          <a-button
            type="primary"
            style="float: right;"
            @click="add"
          >
            {{ $t('setting-user/add') }}
          </a-button>
        </a-col>
      </a-row>
    </a-form>
    <!-- 表格信息 -->
    <a-table
      v-if="!showEditBox"
      :row-key="row=>row.id"
      :columns="columns"
      :data-source="data"
      :pagination="pagination"
      :scroll="{ y: 'calc(100vh - 230px)' }"
      @change="pageChange"
    >
      <!-- 序号 -->
      <span slot="index" slot-scope="text, row, index">
        <div>
          {{ index + 1 + (pagination.current - 1) * 10 }}
        </div>
      </span>
      <!-- 编辑按钮 -->
      <span
        slot="edit"
        slot-scope="text, row"
        class="edit"
        @click="edit(row)"
      >
        <svg-icon icon-class="write" />
      </span>

    </a-table>
    <!-- 显示添加用户盒子 -->
    <div
      v-if="showEditBox"
      class="editBox"
    >
      <a-form-model
        ref="ruleForm"
        class="ant-advanced-search-form"
        :model="form"
        :rules="rules"
      >
        <div class="subTitle">
          {{ $t('register/info') }}
        </div>
        <a-row :gutter="24">
          <a-col span="24">
            <a-form-model-item
              ref="participant_type"
              prop="participant_type"
              :label="$t('register/participantType')+$t('register/participantTypeTip')"
              required
            >
              <a-radio-group v-model="form.participant_type">
                <a-radio value="1">{{ $t('register/person') }}</a-radio>
                <a-radio value="2">{{ $t('register/company') }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item
              ref="name"
              prop="name"
              :label="form.participant_type === '2' ? $t('user-productInfo-brand/name_contact_person') : $t('user-productInfo-brand/name') "
              required
            >
              <a-input v-model="form.name" />
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item
              ref="form"
              prop="form"
              :label="$t('register/gender')"
              required
            >
              <a-radio-group v-model="form.form">
                <a-radio value="1">{{ $t('register/male') }}</a-radio>
                <a-radio value="2">{{ $t('register/female') }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item
              ref="phone"
              prop="phone"
              :label="$t('register/phone')"
              required
            >
              <a-input v-model="form.phone" />
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item
              ref="email"
              prop="email"
              :label="$t('register/email') + $t('register/emailMark')"
              required
            >
              <a-input v-model="form.email" />
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item
              ref="password"
              prop="password"
              :label="$t('register/password')"
              :required="!id"
            >
              <a-input-password v-model="form.password" />
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item
              ref="password_confirmation"
              prop="password_confirmation"
              :label="$t('register/rePassword')"
              :required="!id"
            >
              <a-input-password v-model="form.password_confirmation" />
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item
              ref="identity_type"
              prop="identity_type"
              :label="$t('register/identityType')"
              required
            >
              <a-select
                v-model="form.identity_type"
                show-search
              >
                <a-select-option
                  value="1"
                >
                  {{ $t('register/identity') }}
                </a-select-option>
                <a-select-option
                  value="2"
                >
                  {{ $t('register/passport') }}
                </a-select-option>
                <a-select-option
                  value="3"
                >
                  {{ $t('register/accessPass') }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item
              ref="sfzhm"
              prop="sfzhm"
              :label="$t('register/identificationNumber') "
              required
            >
              <a-input v-model="form.sfzhm" />
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item
              ref="company_name"
              prop="company_name"
              :label="$t('register/name')"
            >
              <a-input v-model="form.company_name" />
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item
              ref="street"
              prop="street"
              :label="$t('user-productInfo-brand/address')"
              required
            >
              <a-input v-model="form.street" />
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item
              ref="position"
              prop="position"
              :label="$t('user-productInfo-brand/position')"
            >
              <a-input v-model="form.position" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col span="6">
            <a-form-model-item
              ref="country"
              prop="country"
              :label="$t('user-productInfo-brand/country')"
              required
            >
              <a-select
                v-model="form.country"
                show-search
              >
                <a-select-option
                  v-for="i in countryFormat[$i18n.locale || 'zh']"
                  :key="i"
                  :value="i"
                >
                  {{ i }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col v-if="form.country === 'China' || form.country === '中国'" span="6">
            <a-form-model-item
              ref="province"
              prop="province"
              :label="$t('admin-judge420/name7')"
            >
              <a-select
                v-model="form.province"
                show-search
                :placeholder="$t('admin-judge420/name7')"
                @change="form.city = ''"
              >
                <a-select-option
                  v-for="i in provinceData"
                  :key="i"
                  :value="i"
                >
                  {{ i }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item
              ref="city"
              prop="city"
              :label="$t('user-productInfo-brand/city')"
              required
            >
              <a-input v-if="form.country !== 'China' && form.country !== '中国'" v-model="form.city" />
              <a-select
                v-if="form.country === 'China' || form.country === '中国'"
                v-model="form.city"
                show-search
                :placeholder="$t('user-productInfo-brand/city')"
                @change="form.region = ''"
              >
                <a-select-option
                  v-for="i in cityData"
                  :key="i"
                  :value="i"
                >
                  {{ i }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col v-if="(form.country === 'China' || form.country === '中国') && (form.city === 'Zhangzhou' || form.city === '漳州')" span="6">
            <a-form-model-item
              ref="region"
              prop="region"
              :label="$t('user-productInfo-brand/region')"
              required
            >
              <a-select
                v-model="form.region"
                show-search
                :placeholder="$t('user-productInfo-brand/region')"
              >
                <a-select-option
                  v-for="i in zhangzhouRegionFormat[$i18n.locale || 'zh']"
                  :key="i"
                  :value="i"
                >
                  {{ i }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col span="12">
            <a-form-model-item
              ref="homepage"
              prop="homepage"
              :label="$t('register/homepage')"
            >
              <a-input v-model="form.homepage" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <!-- 身份 -->
          <a-col span="12">
            <a-form-model-item
              ref="role"
              prop="role"
              :label="$t('setting-user/role')"
              required
            >
              <a-select v-model="form.role" @change="roleChange">
                <a-select-option
                  v-for="i in rolesList"
                  :key="i.value"
                  :value="i.value"
                >
                  {{ i.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!-- 用户标签，最多三个 -->
          <a-col span="12">
            <a-form-item
              :label="$t('view-components-components/user-label')"
              class="writePlate"
            >
              <template v-for="tag in form.user_label">
                <a-tooltip v-if="tag.length > 20" :key="tag" closable :title="tag">
                  <a-tag :key="tag" @close="() => handleClose(tag)">
                    {{ `${tag.slice(0, 20)}...` }}
                  </a-tag>
                </a-tooltip>
                <a-tag v-else :key="tag" closable @close="() => handleClose(tag)">
                  {{ tag }}
                </a-tag>
              </template>
              <template v-if="!form.user_label || !form.user_label.length">
                <!-- 占位置 -->
                <span style="opacity: 0">0</span>
              </template>
              <template>
                <a-input
                  v-if="inputVisible"
                  ref="input"
                  type="text"
                  size="small"
                  :style="{ width: '78px' }"
                  :value="inputValue"
                  @change="handleInputChange"
                  @blur="handleInputConfirm"
                  @keyup.enter="handleInputConfirm"
                />
                <a-tag v-else style="background: #fff; borderStyle: dashed;" @click="showInput">
                  <a-icon type="plus" /> New Tag
                </a-tag>
              </template>
            </a-form-item>
          </a-col>
          <!-- 初评分组，如果role是3就出现 -->
          <a-col
            v-show="form.role === 3"
            span="11"
          >
            <a-form-model-item
              ref="group_id"
              prop="groupId"
              :label="$t('admin-judge/judgeGroup')"
              :required="form.role === 3"
            >
              <a-select v-model="form.groupId" @change="changeGroup">
                <a-select-option
                  v-for="i in groupList"
                  :key="i.id"
                  :value="i.id"
                >
                  {{ i.title }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!-- 初评分组右方图标，点击可以添加分组，如果role是3就出现 -->
          <a-col v-show="form.role === 3" span="1">
            <svg-icon
              icon-class="write"
              style="cursor: pointer;margin-top: 45px;font-size: 24px;"
              @click="groupVisible = true"
            />
          </a-col>
          <!-- 分类信息，如果role是3就出现 -->
          <a-col v-show="form.role === 3" span="24">
            <a-form-model-item
              :label="$t('admin-judge/classification')"
              :required="form.role === 3"
            >
              <div class="checkboxList">
                <div class="inner">
                  <a-checkbox-group v-model="form.group_review_cates" style="width: 100%">
                    <a-row>
                      <a-col v-for="(item, index) in cateList" :key="index" :span="locale === 'en' ? 12 : 8">
                        <a-checkbox :value="item.value">{{ item.name }}</a-checkbox> <span class="number" :style="locale === 'en' ? 'width: 74px' : ''">{{ item.num }}{{ item.num > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}</span>
                      </a-col>
                    </a-row>
                  </a-checkbox-group>
                </div>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <!-- 模态框 -->
    <a-modal v-model="groupVisible" :title="$t('admin-judge/judgeGroup')">
      <div style="text-align: right;margin-bottom: 5px;">
        <a-button
          type="primary"
          @click="propmtVisible = true"
        >
          {{ $t('admin-judge/add') }}
        </a-button>
      </div>
      <!-- 表格2 -->
      <a-table
        :row-key="row=>row.id"
        :columns="groupColumns"
        :data-source="groupList"
        :pagination="false"
        class="table"
        :scroll="{ y: 'calc(100vh - 230px)' }"
      >
        <span slot="name" slot-scope="text, row, index">
          <editable-cell :text="text" @change="editGroup($event, 'title', index)" />
        </span>
        <span
          slot="operation"
          slot-scope="text, row, index"
          class="edit"
          @click="editGroup($event, 'delete', index)"
        >
          <a-icon type="delete" />
        </span>
      </a-table>
      <!-- 底部保存按钮 -->
      <template slot="footer">
        <a-button @click="groupVisible = false">{{ $t('register-verify/close') }}</a-button>
      </template>
    </a-modal>
    <!-- 底部保存按钮 -->
    <footer v-if="showEditBox">
      <a-button @click="save">
        {{ $t('admin-profile-edit/save') }}
      </a-button>
    </footer>
    <Prompt :title="$t('admin-judge/tip17')" :propmt-visible="propmtVisible" @ok="propmtOk" @cancel="propmtCancel" /></div>
</template>
<script>
// 导入时间格式转换
import moment from 'moment'
// 导入API函数
import { users, storeBefore, createUsers, editUsers, groups, addGroup, editGroup, deleteGroup } from '@/api/user'
// 导入语言化数据
import zh from '@/lang/zh.json'
import en from '@/lang/en.json'
// 导入语言化
import { getLKey } from '@/utils/auth'
// 导入编辑组件
import EditableCell from './components/EditableCell'
// 导入子组件
import Prompt from '@/components/Prompt'
// 导入地区数据
import countryFormat from '@/utils/country.js'
import cityFormat from '@/utils/city.js'
import zhangzhouRegionFormat from '@/utils/zhangzhouRegion.js'
import area_cn from '@/utils/area_cn.js' // 中文
import area_en from '@/utils/area_en.js' // 英文
// 导入语言化
const i18n = { zh, en }
const lang = getLKey()
// 自动校验函数，对一些输入框的值进行校验
function emailValidate(rule, value, callback) {
  // if (/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
  // callback()
  // } else {
  //   callback(new Error('邮箱格式不正确'))
  // }
  if (value.indexOf('@') !== -1) {
    callback()
  } else {
    callback(new Error(i18n[lang]['view-components-components/mailError']))
  }
}
// 表格1的列头
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    scopedSlots: { customRender: 'index' },
    width: '70px'
  },
  {
    title: '调用姓名',
    dataIndex: 'name',
    key: 'name',
    width: '150px'
  },
  {
    title: '手机号',
    dataIndex: 'phone',
    key: 'phone',
    width: '150px'
  },
  {
    title: '身份',
    dataIndex: 'role_name',
    key: 'role_name',
    width: '100px'
  },
  {
    title: '',
    dataIndex: 'id',
    key: 'id',
    scopedSlots: { customRender: 'edit' },
    width: '100px'
  }
]
// 表格2的列头
const groupColumns = [
  {
    title: '分组名称',
    dataIndex: 'title',
    key: 'title',
    scopedSlots: { customRender: 'name' },
    width: '100px'
  },
  {
    title: '初评人数',
    dataIndex: 'num',
    key: 'num',
    width: '100px'
  },
  {
    title: '操作',
    dataIndex: 'id',
    key: 'id',
    scopedSlots: { customRender: 'operation' },
    width: '100px'
  }
]

export default {
  components: {
    EditableCell,
    Prompt
  },
  data() {
    return {
      moment, // 时间修正
      searchWord: '', // 搜索框
      pagination: { // 数据总行数，页码数据
        current: 1,
        total: 0
      },
      labelCol: { span: 7 }, // label占据7/24
      wrapperCol: { span: 12 }, // 空格占据12/24
      number: { // 数值，暂时未出现
        value: 11
      },
      data: [], // 第一个表格的表格信息
      columns, // 第一个表格列头
      groupColumns, // 第二个表格列头
      form: { // 添加的新用户
        email: '', // 邮箱
        password: '', // 密码
        password_confirmation: '', // 确认密码
        firstname: '', // 第一个名字
        lastname: '', // 最后的名字
        name: '', // 姓名
        participant_type: '', // 参与者类型
        form: '', // 性别
        phone: '', // 手机
        identity_type: '', // 证件类型
        sfzhm: '', // 身份证号码
        company_name: '', // 单位名称
        street: '', // 地址
        position: '', // 职位
        country: '中国', // 国家
        province: '', // 省份
        city: '', // 城市
        region: '', // 区域
        homepage: '', // 主页
        role: '', // 判断当前用户选择的身份
        manager_id: '', // 暂时没用
        user_label: [], // 用户标签，最多为三个
        group_id: '', // 分组的ID
        groupId: '', // 兼容ant, ant校验的key不能用下划线
        group_review_cates: [] // 绑定选中的分类
      },
      rules: { // 规则，可能是验证规则
        participant_type: [
          { required: true, message: i18n[lang]['register/select-participant-type'], trigger: ['change', 'blur'] }
        ],
        identity_type: [
          { required: true, message: i18n[lang]['register/select-identity-type'], trigger: ['change', 'blur'] }
        ],
        sfzhm: [
          { required: true, message: i18n[lang]['register/select-identification-number'], trigger: ['change', 'blur'] }
        ],
        form: [
          { required: true, message: i18n[lang]['register/select-gender'], trigger: ['change', 'blur'] }
        ],
        name: [
          { required: true, message: i18n[lang]['admin-user-user/pname'], trigger: ['change', 'blur'] }
        ],
        street: [
          { required: true, message: i18n[lang]['user-address/paddress'], trigger: ['change', 'blur'] }
        ],
        city: [
          { required: true, message: i18n[lang]['register/pcity'], trigger: ['change', 'blur'] }
        ],
        region: [
          { required: true, message: i18n[lang]['register/pregion'], trigger: ['change', 'blur'] }
        ],
        country: [
          { required: true, message: i18n[lang]['register/pcountry'], trigger: ['change', 'blur'] }
        ]
      },
      showEditBox: false, // 是否展示编辑盒子
      id: '', //
      rolesList: [], // 身份列表
      cateList: [], // 分类列表信息
      groupsOfCates: [], //
      managersList: [], // 客户经理列表
      groupList: [], // 表格而的表格信息
      inputVisible: false, // 是否展示标签
      inputValue: '', // 标签的值
      groupVisible: false, // 分类是否课件
      propmtVisible: false, //
      countryFormat: countryFormat,
      cityFormat: cityFormat,
      zhangzhouRegionFormat: zhangzhouRegionFormat
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    provinceData() { // 所有的省份
      return this.locale === 'en' ? area_en.provinceData : area_cn.provinceData
    },
    cityData() { // 所有的城市
      const area = this.locale === 'en' ? area_en : area_cn
      return area.cityData[this.form.province]
    }
  },
  watch: {
    locale(e) { // 语言化
      this.columns[0].title = this.$t('admin-judge/index')
      this.columns[1].title = this.$t('user-productInfo-brand/name')
      this.columns[2].title = this.$t('register/phone')
      this.columns[3].title = this.$t('setting-user/role')

      this.groupColumns[0].title = this.$t('admin-judge/groupName')
      this.groupColumns[1].title = this.$t('admin-judge/numberOfReviewers')
      this.groupColumns[2].title = this.$t('admin-products-products/operating')
    }
  },
  created() { // 语言化
    this.columns[0].title = this.$t('admin-judge/index')
    this.columns[1].title = this.$t('user-productInfo-brand/name')
    this.columns[2].title = this.$t('register/phone')
    this.columns[3].title = this.$t('setting-user/role')

    this.groupColumns[0].title = this.$t('admin-judge/groupName')
    this.groupColumns[1].title = this.$t('admin-judge/numberOfReviewers')
    this.groupColumns[2].title = this.$t('admin-products-products/operating')

    this.getList() // 执行信息初始化
    this.getBefore() // 执行
  },
  methods: {
    getBefore() { // 初始化身份列表信息，和分类列表信息，分类分组信息，客户经理列表信息
      console.log('1')
      storeBefore().then(res => {
        this.rolesList = res.roles
        this.cateList = res.cates
        this.groupsOfCates = res.groups
        this.managersList = res.managers
        this.managersList = [{
          id: 0,
          firstname: '',
          lastname: '无'
        }].concat(this.managersList)
      }).catch(res => {
        console.error(res)
      })
    },
    getList(page) { // 判断有无页码传入，没有为1，通过页码和关键字进行查询信息，且存储总行数和页码数据
      const params = {
        search: this.searchWord,
        page: (typeof page === 'number' ? page : this.pagination.current)
      }
      users(params).then(res => {
        this.data = res.data
        this.pagination.total = res.total
        this.pagination.current = res.current_page
      }).catch(res => {
        console.error(res)
      })
    },
    add() { // 打开编辑盒子，且对所有可输入信息的input输入框进行检测，且对form进行初始化，如果身份不是初评员，删除某一条属性
      this.id = ''
      this.showEditBox = true
      this.rules = {
        email: [
          { required: true, message: this.$t('admin-user-user/pemaill'), trigger: ['blur', 'change'] },
          { validator: emailValidate, trigger: ['change', 'blur'] }
        ],
        password: [
          { min: 8, max: 32, message: this.$t('admin-user-user/limit'), trigger: ['change', 'blur'] },
          { required: true, message: this.$t('admin-user-user/limit'), trigger: ['blur', 'change'] }
        ],
        password_confirmation: [
          { required: true, message: this.$t('admin-user-user/limit'), trigger: ['blur', 'change'] }
        ],
        firstname: [
          { required: true, message: this.$t('admin-user-user/pinputn'), trigger: ['blur', 'change'] }
        ],
        lastname: [
          { required: true, message: this.$t('admin-user-user/psurname'), trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, message: this.$t('admin-user-user/pinputp'), trigger: ['blur', 'change'] }
        ]
      }
      this.form = {
        email: '',
        password: '',
        password_confirmation: '',
        firstname: '',
        lastname: '',
        name: '',
        participant_type: '',
        form: '',
        phone: '',
        identity_type: '',
        sfzhm: '',
        company_name: '',
        street: '',
        position: '',
        country: '中国',
        province: '',
        city: '',
        region: '',
        homepage: '',
        role: '',
        manager_id: '',
        user_label: [],
        group_id: '',
        group_review_cates: [],
        groupId: ''
      }

      if (this.form.role !== 3) {
        delete this.rules.group_id
      }
      this.getGroups()
    },
    edit(row) { // 修改某一行的信息
      console.log('row', row)
      this.rules = {
        email: [
          { required: true, message: this.$t('admin-user-user/pemaill'), trigger: ['blur', 'change'] },
          { validator: emailValidate, trigger: ['change', 'blur'] }
        ],
        password: [
          { min: 8, max: 32, message: this.$t('admin-user-user/limit'), trigger: ['change', 'blur'] }
        ],
        password_confirmation: [
          { min: 8, max: 32, message: this.$t('admin-user-user/limit'), trigger: ['change', 'blur'] }
        ],
        firstname: [
          { required: true, message: this.$t('admin-user-user/pinputn'), trigger: ['blur', 'change'] }
        ],
        lastname: [
          { required: true, message: this.$t('admin-user-user/psurname'), trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, message: this.$t('admin-user-user/pinputp'), trigger: ['blur', 'change'] }
        ]
      }

      this.id = row.id
      // 需要转换为字符串的数字类型字段
      const numberFields = ['participant_type', 'form', 'identity_type']
      // 需要设置默认值的字段
      const defaultFields = {
        country: '中国',
        manager_id: '',
        group_id: ''
      }
      // 使用接口返回的数据初始化表单
      Object.keys(this.form).forEach(key => {
        if (key === 'password' || key === 'password_confirmation') {
          this.form[key] = '' // 密码字段置空
        } else if (numberFields.includes(key)) {
          this.form[key] = row[key] !== null ? String(row[key]) : ''
        } else if (key === 'user_label' && row.user_tag) {
          this.form[key] = row.user_tag.map(i => i.label)
        } else if (key === 'groupId') {
          this.form[key] = row.group_id
        } else if (key in defaultFields) {
          this.form[key] = row[key] || defaultFields[key]
        } else {
          this.form[key] = row[key] || this.form[key]
        }
      })
      this.$set(this.form, 'group_review_cates')
      this.form.group_review_cates = row.group_review_cates ? row.group_review_cates.split(',').map(i => Number(i)) : []
      this.showEditBox = true

      if (this.form.role === 3) {
        this.rules.role = [
          { required: true, message: this.$t('admin-user-user/selectid'), trigger: ['blur', 'change'] }
        ]
        this.rules.groupId = [
          { required: true, message: this.$t('admin-judge/tip18'), trigger: ['blur', 'change'] }
        ]
      }
      this.getGroups()
    },
    save() { // 对数据进行保存
      const data = JSON.parse(JSON.stringify(this.form))
      delete data.groupId
      data.group_review_cates = data.group_review_cates.join(',')

      this.$refs.ruleForm.validate(async valid => { // 检测某一个输入框的输入是否合法，不合法提示，合法会重新初始化，没有值不会发送请求
        if (valid) {
          if (data.role === 3 && !data.group_review_cates) {
            return this.$message.warning({ content: this.$t('admin-judge/tip19'), key: 'message', duration: 4 })
          }
          if (!this.id) {
            createUsers(data).then(res => {
              this.$message.success({ content: this.$t('admin-password-password/savey'), key: 'message', duration: 4 })
              this.showEditBox = false
              setTimeout(() => {
                this.getList()
                this.getBefore()
              }, 3000)
            }).catch(res => {
              console.error(res)
            })
          } else {
            const id = this.id
            editUsers(id, data).then(res => {
              this.$message.success({ content: this.$t('admin-rewards-rewards/modify'), key: 'message', duration: 4 })
              this.showEditBox = false
              setTimeout(() => {
                this.getList()
                this.getBefore()
              }, 3000)
            }).catch(res => {
              console.error(res)
            })
          }
        } else {
          this.$message.warning({ content: this.$t('view-components-components/perfect'), key: 'message', duration: 4 })
          console.log('error submit!!')
          return false
        }
      })
    },
    pageChange(e) { // 页码改变
      this.getList(e.current)
    },
    handleClose(removedTag) { // 移除标签
      const tags = this.form.user_label.filter(tag => tag !== removedTag)
      this.form.user_label = tags
    },
    showInput() { // 展示标签，且聚焦
      this.inputVisible = true
      this.$nextTick(function() {
        this.$refs.input.focus()
      })
    },

    handleInputChange(e) { // 输入框的值发生改变后，存储起来
      this.inputValue = e.target.value
    },
    handleInputConfirm() { // 点击保存时，
      const inputValue = this.inputValue
      let tags = this.form.user_label
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue]
      }
      this.inputVisible = false
      this.inputValue = ''
      this.form.user_label = tags
    },
    getGroups() { // 请求函数并刷新分类的信息
      groups().then(res => {
        for (const i in res) {
          res[i].num = String(res[i].num)
        }
        this.groupList = res
      })
    },
    editGroup(event, key, index) { // 编辑分类
      switch (key) {
        case 'add': {
          const data = {
            title: event
          }
          addGroup(data).then(res => {
            this.getGroups()
          })
          break
        }
        case 'title': {
          const data = {
            title: event
          }
          const id = this.groupList[index].id
          if (this.groupList[index].title !== data.title) {
            editGroup(id, data).then(res => {
              this.getGroups()
            })
          }
          break
        }
        case 'delete': {
          const id = this.groupList[index].id
          deleteGroup(id).then(res => {
            if (this.form.group_id === id) {
              this.form.group_id = ''
            }
            this.getGroups()
          })
          break
        }
        default: break
      }
    },
    propmtOk(e) { // 点击ok
      this.editGroup(e, 'add')
      this.propmtVisible = false
    },
    propmtCancel(e) { // 点击取消
      this.propmtVisible = false
    },
    changeGroup(e) { // 分组改变
      this.form.group_id = e
      this.groupsOfCates.filter(i => i.id === e).map(i => {
        this.$set(this.form, 'group_review_cates', i.group_review_cates.split(',').map(i => Number(i)))
      })
    },
    roleChange(e) { // 身份发生改变
      if (this.form.role === 3) {
        this.rules.role = [
          { required: true, message: this.$t('admin-user-user/selectid'), trigger: ['blur', 'change'] }
        ]
        this.rules.groupId = [
          { required: true, message: this.$t('admin-judge/tip18'), trigger: ['blur', 'change'] }
        ]
      } else {
        delete this.rules.role
        delete this.rules.groupId
      }
    }
  }
}
</script>
<style scoped>
  .searchBox {
    background: #ffffff;
    height: 100px;
    line-height: 32px;
    box-sizing: border-box;
    padding: 30px 20px;
    margin-bottom: 24px;
  }

  .searchBox .an.ant-advanced-search-form .ant-form-itemt-form-item {
    margin-bottom: 0;
  }

  .edit {
    cursor: pointer;
  }

  .editBox {
    position: absolute;
    top: 0;
    background: #f8f8f8;
    padding-right: 25px;
    padding-bottom: 90px;
  }

  .subTitle {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 17px;
  }

  .tip {
    font-size: 14px;
    color: #999999;
    margin-top: 4px;
    line-height: 14px;
  }

  footer {
    width: 100%;
    height: 70px;
    text-align: right;
    padding: 19px 24px;
    background: #ffffff;
    position: fixed;
    bottom: 0;
    right: 0;
  }

  footer button {
    margin-left: 16px;
  }

  .checkboxList {
    width: 100%;
    margin-bottom: 100px;
  }

  .checkboxList .inner {
    background: #ffffff;
    border: 1px solid rgba(224, 224, 224, 1);
    padding: 44px 73px;
  }

  .checkboxList .title {
    font-weight: bold;
    margin-bottom: 8px;
  }

  .checkboxList label {
    margin-bottom: 34px;
  }

  .checkboxList .number {
    float:left;
    width: 46px;
  }

  .subTitle {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-top: 40px;
    margin-bottom: 17px;
  }
</style>
<style>
  .writePlate .ant-form-item-control {
    background: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 0 11px;
  }

  .ant-select-dropdown-menu-item {
    white-space: pre;
  }
</style>
